import React from 'react'
import styled, { css } from 'styled-components/macro'
import { rem } from 'polished'

import { Currency } from '@tiltify/ui'
import { useRouteContext } from 'contexts/RouteContext'
import { RedButton } from 'components/styles'
import JingleJamPink from 'assets/JJ.png'
import pattern from 'assets/BlueBackground.png'
import hero from 'assets/HeroBackground.png'

const Background = styled.div`
  background: url(${hero});
  background-size: cover;
  background-position: center;
  color: #fff;
`
const Pattern = styled.div`
  background: url(${pattern});
  height: 170px;
  clip-path: polygon(50% 50%, 100% 0, 100% 100%, 0 100%, 0 0);
`

const LogoWrapper = styled.div`
  display: flex;
  justify-content: center;
  margin: ${rem(37)} auto;

  && img {
    width: 200px;
  }
`

const Total = styled.p`
  margin: 0;
  text-align: center;
  font-size: ${rem(14)};
  line-height: 16px;
`

const Heading = styled.h1`
  font-size: ${rem(32)};
  line-height: 40px;
  text-align: center;
  max-width: 750px;
  margin: 20px auto;
`
const Amount = styled.div<{ marginBottom: boolean }>`
  font-size: ${rem(32)};
  font-weight: bold;
  display: flex;
  justify-content: center;

  ${({ marginBottom }) =>
    marginBottom &&
    css`
      margin-bottom: ${rem(80)};
    `}
`

const ButtonContainer = styled.div`
  margin-top: ${rem(37)};
  margin-bottom: ${rem(80)};
  display: flex;
  justify-content: center;

  @media (max-width: 552px) {
    flex-direction: column;
    align-items: center;
    margin-bottom: ${rem(40)};
  }
`

export const Hero = (): JSX.Element => {
  const { fundraisingEvent } = useRouteContext()

  return (
    <>
      <Background>
        <LogoWrapper>
          <img src={JingleJamPink} alt='Jingle Jam Logo' />
        </LogoWrapper>
        <Heading>
          Thank you to everybody who has supported this year's Jingle Jam! Donations are now closed.
          See you all next year!
        </Heading>
        <Total>TOTAL RAISED</Total>
        <Amount marginBottom={!fundraisingEvent?.visibility?.donate}>
          <Currency
            value={fundraisingEvent?.totalAmountRaised?.value}
            currency={fundraisingEvent?.totalAmountRaised?.currency}
          />
        </Amount>

        {fundraisingEvent?.visibility?.donate && (
          <ButtonContainer>
            <RedButton
              as='a'
              href='https://donate.tiltify.com/@yogscast/jingle-jam-2022?rewardId=175374'
            >
              Donate Now!
            </RedButton>
          </ButtonContainer>
        )}
        <Pattern />
      </Background>
    </>
  )
}
